import { curry, difference, equals, filter, keys, pick, pipe, reduce, toPairs, union } from "ramda";

type AnyObject = Record<string, unknown>;

export const objectDifferenceLeft = <T extends AnyObject, U extends AnyObject>(
  a: T,
  b: U,
  pickedKeys?: (keyof T)[],
): AnyObject[] => {
  const iteratee = (acc: AnyObject[], [key, value]: [string, unknown]) => {
    acc.push({ [key]: value });
    return acc;
  };
  const k: (keyof T)[] = pickedKeys ?? keys(a);
  // @ts-expect-error rambda uses any
  const _: (obj: AnyObject) => AnyObject[] = pipe(curry(pick)(k), toPairs, (list) => reduce(iteratee, [], list));

  return difference(_(a), _(b));
};

/**
 * Returns an array of keys where values differ between two objects
 * @param obj1
 * @param obj2
 * @example getDifferingKeys({a: 1, b: 2, c: 0}, {a: 1, b: 3}); // [b, c]
 */
export const getDifferingKeys = (obj1: object, obj2: object) => {
  const allKeys = union(keys(obj1), keys(obj2));
  return filter((key) => !equals(obj1[key], obj2[key]), allKeys);
};
